import React from 'react';
import { BaseIcon } from 'components';

export const HamburguerIcon = (props) => {
  return(
    <BaseIcon props={props} className={`hamburguer-icon ${props.className || ''}`}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 16">
        <path fill="#000000" d="M0 0h22v2H0zM0 7h22v2H0zM0 14h22v2H0z"/>
      </svg>
    </BaseIcon>
  )
};
